import { FormsService } from 'src/app/services/forms/forms.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
  AfterContentChecked,
  AfterViewChecked,
  Component,
  OnInit,
  ViewEncapsulation,
  NgZone,
  HostListener,
  ChangeDetectorRef
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { Event as NavigationEvent, NavigationExtras, NavigationStart, Router } from '@angular/router';
import { SwPush, SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import * as CryptoJS from 'crypto-js';
import * as Feather from 'feather-icons';
import Bowser from 'bowser';
import { forkJoin, Subscription, throwError } from 'rxjs';
import { catchError, filter, retry } from 'rxjs/operators';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { $b } from '../libs/browser_utils.js';
import { EventBus } from '../libs/event_publisher.js';
import { DevicePermissionsComponent } from './common-features/device-permissions/device-permissions.component';
import { AppdataService } from './services/app-data/appdata.service';
import { ChatqueueService } from './services/chatqueue/chatqueue.service';
import { CommunicationInterfaceService } from './services/communicationInterface/communication-interface.service';
import { LivechatStartService } from './services/livechat-start/livechat-start.service';
import { MessengerService } from './services/messenger/messenger.service';
import { WebsocketService } from './services/websockets/websocket.service';
import { LivechatAVLibrarySettings } from '../libs/livechat_ref.js';

declare var window: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, AfterViewChecked, AfterContentChecked {
  cacheBuster: number = new Date().getTime();
  configLoaded = false;
  configUrl = 'assets/app-config.json';
  labelUrl = 'app-labels.json';
  isCaptchaLoaded = true;
  sessionStarted: boolean;
  eventBus: any = EventBus;
  queuePosition: any;
  who = '';
  connectedAgents = [];
  messages = [];
  headerLabel: any;
  legacy = false;
  isCaptchaEnabled: any;
  appConfig: any;
  parsedData: any;
  interactionID: any;
  tokenReceived = false;
  encryptKey = 'ThisIsTheSecret';
  existingAgent: NavigationExtras;
  mySubscription: any;
  UserConnectednavigationExtras: NavigationExtras;
  colorCodes: any = ['#E74C3C', '#2980B9', '#1ABC9C', '#F39C12', '#2C3E50', '#FF5722', '#009688', '#E91E63', '#3F51B5'];
  progessBarStatus: boolean;
  subcriberInstance: Subscription;
  livechatStatus: any;
  showLiveChatStatus: any;
  queuePos = 0;
  sessionId: string;
  appLabels: any;
  defaultFirstAgentTheme: string;
  browserOptions = {};
  isBrowserValid: boolean;
  browserCheckEnabled: boolean = false;
  appVersion: string;
  enableMinimization: boolean = false;
  enableClose: boolean = false;
  minimizeTriggerKey: string = '';
  closeTriggerKey: string = '';
  snackbarHorizontalPosition: any;
  snackbarVerticalPosition: any;
  isChatbotMode: boolean = false;
  isPermissionDialogTriggered: boolean = false;
  hasQueueAudioPlayedWithMute: boolean = false;
  isLoading: boolean = false;
  private queueSnackBarRef: MatSnackBarRef<any> | null = null;

  constructor(
    private route: Router,
    private appDataService: AppdataService,
    private startService: LivechatStartService,
    private queueService: ChatqueueService,
    private websocketService: WebsocketService,
    private snackBar: MatSnackBar,
    public messengerService: MessengerService,
    private http: HttpClient,
    private dialog: MatDialog,
    private commInterface: CommunicationInterfaceService,
    private swpush: SwPush,
    private swupdate: SwUpdate,
    public zone: NgZone,
    public formsService: FormsService,
    private cdr: ChangeDetectorRef
  ) {
    try {
      this.appDataService?.labelObservable?.subscribe((updatedLabels: any) => {
        this.appLabels = updatedLabels;
        this.cdr.detectChanges();
      })
      console.log('%c AppComponent', 'color:white; background: blue;');
      this.commInterface.logToServer('info', 'AppComponent.constructor', 'App component initialized');
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);

      this.subcriberInstance = this.messengerService.handleProgressBarObservable.subscribe((x) => {
        this.progessBarStatus = x;
      });
    } catch (error) {
      console.error('%c Error Occured in constructor', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'constructor', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.constructor', JSON.stringify(error));
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler() {
    try {
      this.commInterface.logToServer('info', 'AppComponent.beforeUnloadHandler', 'Init');
      if (this.appConfig?.channelConfiguration[this.appConfig?.channelConfiguration?.chatmode]?.sessionEndOnRefresh) {
        this.commInterface.logToServer('info', 'AppComponent.beforeUnloadHandler', 'Session ending!');
        if (this.appConfig.websocket.enabled) {
          this.websocketService.endWebSocket(this.websocketService.interactionID);
        } else {
          this.commInterface.end('Customer ended', '');
        }
      }
    } catch (error) {
      console.error('%c Error Occured in HostListener.beforeUnloadHandler', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'HostListener.beforeUnloadHandler', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.HostListener.beforeUnloadHandler',
        JSON.stringify(error)
      );
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    try {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    } catch (error) {
      console.error('%c Error Occured in HostListener.onWindowResize', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'HostListener.onWindowResize', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.HostListener.onWindowResize',
        JSON.stringify(error)
      );
    }
  }

  /**
   * Method to get the configu.n........rations set at UI level, related to application
   */
  loadConfig = forkJoin([
    this.http.get(`${this.configUrl}?v=${this.cacheBuster}`).pipe(retry(3), catchError(this.handleError)),
  ]);

  /**
   * Method to handle forkjoin catch error
   * @param error HttpErrorResponse
   */
  private handleError(error: HttpErrorResponse): any {
    if (error.error instanceof ErrorEvent) {
      console.error('%c Error Occured in handleError - Clientside/Network error', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleError - Clientside/Network error', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.handleError - Clientside/Network error',
        JSON.stringify(error)
      );
    } else {
      console.error('%c Error Occured in handleError - Backend error', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleError - Backend error', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.handleError - Backend error',
        JSON.stringify(error)
      );
    }
    return throwError('Something bad happened; please try again later.');
  }

  ngOnInit(): void {
    try {
      this.loadConfig.subscribe((dt) => {
        this.configLoaded = true;
        console.log('Visual IVR Configurations :', dt);
        this.appDataService.setConfig(dt[0]);
        this.appConfig = this.appDataService.getConfig();
        this.appLabels = this.appDataService.getLabels();
        this.isChatbotMode = this.appConfig?.chatBot?.enabled;
        if (this.appConfig?.Miscellaneous?.preventPullDownToRefresh) {
          document.body.classList.add('prevent-pulldown-refresh');
        }
        if (this.appConfig?.Miscellaneous?.LiveChatAvEndMethod) {
          LivechatAVLibrarySettings.LiveChatAvEndMethod = this.appConfig?.Miscellaneous?.LiveChatAvEndMethod;
        }
        // Enable AV reporting if enabled in configurations
        LivechatAVLibrarySettings.LiveChatAvEnableReporting = this.appConfig.Miscellaneous?.enableAVReporting ?? false;
        // Disable AV SS request if enabled in configurationsm
        LivechatAVLibrarySettings.LiveChatAvDisableSSRequest = this.appConfig.Miscellaneous?.disableAVScreenShareRequest ?? false;
        
         if (!this.appConfig?.websocket?.enabled && this.isLiveChat1Enabled()) {
           window.livechat.avcomm_ = null;
           window?.LiveChatAvCommCreateUsingLivechat();
         }

        // adding theme class configured in app config to body as a part of theme impl
        this.appConfig?.theme !== ''
          ? document.body.classList.add(this.appConfig.theme)
          : document.body.classList.add('tetherfi');
        this.enableMinimization = this.appConfig?.Miscellaneous?.crossWindowCommunication?.enableMinimization;
        this.enableClose = this.appConfig?.Miscellaneous?.crossWindowCommunication?.enableClose;
        this.snackbarHorizontalPosition =
          this.appConfig?.Miscellaneous?.snackbarPosition?.horizontalPosition || 'center';
        this.snackbarVerticalPosition = this.appConfig?.Miscellaneous?.snackbarPosition?.verticalPosition || 'top';

        if (this.enableMinimization || this.enableClose) document.body.style.transform = 'translateY(40px)';

        this.minimizeTriggerKey =
          this.appConfig?.Miscellaneous?.crossWindowCommunication?.postMessageKeys?.minimizeTrigger;
        this.closeTriggerKey = this.appConfig?.Miscellaneous?.crossWindowCommunication?.postMessageKeys?.closeTrigger;

        if (window.location.href.toString().includes('/captcha')) {
          if (this.isCaptchaEnabled == false) {
            // this.startService.checkforLivechatStart('');
          }
        }

        this.startService.chatMode = this.appConfig.channelConfiguration.chatmode;
        this.showLiveChatStatus = this.appConfig.Realtime.LivechatLogs;
        this.defaultFirstAgentTheme = this.appConfig?.LivechatComponent?.defaultReceivedMsgAgentTheme;
        this.setAppVersion();
        if (this.appConfig?.websocket?.enabled) {
          console.debug('Websocket enabled - initalize websocket');
          this.commInterface.sendUIDebug('AppComponent', 'ngOnInit', 'Websocket enabled - initalize websocket');
          this.websocketService.initalizeWebsocket(this.appConfig);
          this.websocketEvent();
        } else {
          console.debug('Livechat Comm interface enabled - open comm interface');
          this.commInterface.sendUIDebug(
            'AppComponent',
            'ngOnInit',
            'Livechat Comm interface enabled - open comm interface'
          );
          this.commInterface.registerCallbackEvents();
          this.commInterface.receivedChatbotMsg();
          this.livechat2ReceivedMessages();
          this.commInterface.open();
          this.commInterface.logToServer('info', 'AppComponent.OnInit', 'Open');
        }

        this.commInterface.triggerAudio();

        // to open device permission popup based on the config and if enabled, restrict the users in proceeding without
        //permission
        console.log('test', $b.GetLocalStorage('chatActive'));
        this.commInterface.logToServer(
          'info',
          'AppComponent.ngOnInit',
          `Device permissions configurations - ${JSON.stringify(this.appConfig?.permissionsConfig)}`
        );

        if (
          this.appConfig?.permissionsConfig?.enableRestriction &&
          !$b.GetSessionStorage('sessionStarted') &&
          !this.isPermissionDialogTriggered
        )
          this.getDevicePermissions();
          else
          this.commInterface.logToServer(
            'info',
            'AppComponent.ngOnInit',
            `Skipping device permission check as enableRestriction - ${
              this.appConfig?.permissionsConfig?.enableRestriction
            }, sessionStarted - ${$b.GetSessionStorage('sessionStarted')}, dialog triggered - ${
              this.isPermissionDialogTriggered
            }`
          );

        this.commInterface.checkDeviceSupport();
        if (this.appConfig?.browserSupport?.checkEnabled) {
          this.browserCheckEnabled = this.appConfig?.browserSupport?.checkEnabled;
          this.browserOptions = this.appConfig?.browserSupport.browserOptions;
          this.checkBrowserSupport();
        }   
        if(!this.sessionId) {
          this.commInterface.isCaptchaEnabledStatus();
        }     
        if (this.appConfig?.permissionsConfig?.enableAVcheck || this.appConfig?.enableAVcheckOnStart) {
          this.commInterface.getAudioVideoInputs();
        } else {
          this.commInterface.logToServer(
            'info',
            'AppComponent.ngOnInit',
            `Skipping get audio video inputs as -  enableAvCheck ${this.appConfig?.permissionsConfig?.enableAVcheck}, enableAVcheckOnStart - ${this.appConfig?.enableAVcheckOnStart}`
          );
        }
      });

      /**
       * Subscribing for the livechat callback events and then handling different scenarios
       */
      this.commInterface.callbacksObservable.subscribe((callbackData) => {
        console.log('CallbackData', callbackData);
        this.commInterface.logToServer('info', 'AppComponent.callbacksObservable', JSON.stringify(callbackData));
        try {
          switch (callbackData.callbackName) {
            case 'OpenFailed':
              this.handleOpenFailed(callbackData.params);
              break;
            case 'OpenSuccess':
              this.handleOpenSuccess(callbackData.params);
              break;
            case 'StartSuccess':
              this.handleStartSuccess(callbackData.params);
              break;
            case 'StartFailed':
              this.handleStartFailed(callbackData.params);
              break;
            case 'RemoteUserConnected':
              // tslint:disable-next-line: max-line-length
              this.handleRemoteUserConnected(
                callbackData.params.name,
                callbackData.params.agentId,
                callbackData.params.sessionID,
                callbackData.params.extraParam
              );
              break;
            case 'MessageReceived':
              // time wont be there fr livemessages so it is null
              this.handleMessageReceivedEvent(
                callbackData.params.agent,
                callbackData.params.message,
                '',
                callbackData.params.id
              );
              break;
            case 'ConferenceUserLeft':
              this.handleConferenceUserLeft(callbackData.params.agent, '', callbackData.params.message);
              break;
            case 'UserJoining':
              this.handleUserJoining(callbackData.params.agent);
              break;
            case 'CallbackAutoRegistered':
              this.handleCallbackAutoRegistered(callbackData.params);
              break;
            case 'TypingStateChanged':
              this.handleTypingStateChanged(callbackData.params.agent, callbackData.params.state);
              break;
            case 'AppMessageEvent':
              this.handleAppMessageEvent(
                callbackData.params.agent,
                callbackData.params.message,
                callbackData.params.id
              );
              break;
            case 'InternalServerError':
              this.handleInternalServerError(callbackData.params);
              break;
            case 'CallQueued':
              this.handleCallQueued(callbackData.params.queuePos, callbackData.params.queueType);
              break;
            case 'ServerStateChanged':
              this.handleServerStateChanged();
              break;
            case 'ServersideEnd':
              this.queueService.setQueueStatus(false);
              this.handleOnEnd(callbackData.params.initiator, callbackData.params.reason);
              break;
            case 'ClientsreasoneEnd':
              this.queueService.setQueueStatus(false);
              this.handleOnEnd(callbackData.params.initiator, callbackData.params.reason);
              break;
            case 'End':
              this.queueService.setQueueStatus(false);
              this.handleOnEnd(callbackData.params.initiator, callbackData.params.reason);
              break;
            case 'OpenStartTimedOut':
              this.handleCaptchaExpiry();
              break;
            case 'CaptchaEnabledStatus':
              this.isCaptchaEnabled = callbackData.params;
              console.log("isCaptchaEnabled from Tcomm ", this.isCaptchaEnabled );
               // Check if Captcha is Enabled and route to captcha
              if (this.isCaptchaEnabled === true) {
                setTimeout(() => {
                  this.zone.run(() => {
                    this.route.navigate(['captcha'], {
                      queryParams: { ...this.startService.queryParameters },
                      queryParamsHandling: 'preserve'
                    });
                  });
                }, 100);
              } else {
                if(this.tokenReceived) {
                  this.startService.checkforLivechatStart('');
                }
                else {                                    
                const startSessionTimer = setInterval(() => {
                  if(this.tokenReceived) {
                    this.startService.checkforLivechatStart('');
                    clearInterval(startSessionTimer);
                    }
                  }, 5000);
                }                
              }
          }
        } catch (error) {
          console.error('Exception in AppComponent.commInterface.callbacksObservable', error);
          this.commInterface.sendUIErrors('AppComponent', 'ngOnInit', error);
        }
      });

      this.commInterface.livechatConferenceAgentEventObservable.subscribe((eventData) => {
        console.log('livechat conference agent event', eventData);
        this.commInterface.logToServer('info', 'AppComponent.Livechat.conferenceAgentEvent', eventData.eventName);
        try {
          switch (eventData.eventName) {
            case 'conferenceconnected': {
              this.handleRemoteUserConnected(
                eventData.data.agentName,
                eventData.data.agentId,
                '',
                JSON.stringify({ agentType: 'agent', conferenceType: '', profilePicture: '' })
              );
              break;
            }
            case 'conferencedisconnected': {
              this.handleConferenceUserLeft(eventData.data.agentId, '', 'Conference agent force left');
              break;
            }
          }
        } catch (error) {
          console.error('Exception in AppComponent.commInterface.livechatConferenceAgentEventObservable', error);
          this.commInterface.sendUIErrors('AppComponent', 'ngOnInit', error);
        }
      });

      this.checkForUpdate();
      if ('serviceWorker' in navigator) {
        this.messengerService.subscribeToNotification();
      }

      /**
       * Trigger on received notification
       */
      this.swpush.notificationClicks.subscribe((event) => {
        console.log('Received notification: ', event);
        const url = event.notification.data.url;
        window.open(url, '_blank');
      });
    } catch (error) {
      console.error('%c Error Occured in ngOnInit', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'ngOnInit', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.ngOnInit', JSON.stringify(error));
    }
  }

  ngAfterViewChecked() {
    Feather.replace();
  }

  /**
   * Check the route and then show logs for livechat sdk events in the bottom.
   * Disabled for chat page
   */
  ngAfterContentChecked(): void {
    try {
      this.zone.run(() => {
        this.route.events.subscribe((event: NavigationEvent) => {
          if (event instanceof NavigationStart) {
            if (event.url.includes('chat')) {
              this.showLiveChatStatus = false;
            } else {
              this.showLiveChatStatus = this.appConfig?.Realtime?.LivechatLogs;
            }
          }
        });
      });
    } catch (error) {
      console.error('%c Error Occured in ngAfterContentChecked', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'ngAfterContentChecked', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.ngAfterContentChecked',
        JSON.stringify(error)
      );
    }
  }

  /**
   * Decrypt the app-config fetched from localstorage
   */
  decryptAppConfig() {
    const decryptData = CryptoJS.AES.decrypt($b.GetLocalStorage('appconfig'), this.encryptKey);
    const obj = JSON.parse(decryptData.toString(CryptoJS.enc.Utf8));
    this.appConfig = obj;
  }

  /**
   * Method to listen to the new window event which will be posted by the newly opened window
   */
  initiateDuplicateWindowListener(): void {
    try {
      const channel = new BroadcastChannel('visual-ivr-window-channel');
      channel.addEventListener('message', (event: any) => {
        if (event.data.channelData == 'new-channel-opened') {
          this.commInterface.logToServer('info', 'AppComponent.initiateDuplicateWindowListener', 'Session ending!');
          this.commInterface.end('Duplicate window opened', '');
        }
        console.log(event);
      });
    } catch (error) {
      console.error('%c Error Occured in initiateDuplicateWindowListener', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'initiateDuplicateWindowListener', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.initiateDuplicateWindowListener',
        JSON.stringify(error)
      );
    }
  }

  /**
   * Custom logger method
   * @param type : Logger type
   * @param method : Method Name
   * @param log : Log Message
   * @param show : Show logger or not
   */
  log(type: string, method: string, log: string, show: boolean) {
    if (show === true) {
      console.log(new Date() + ' -' + type + ' -', method + ' -', log);
      this.commInterface.logToServer('info', `AppComponent.${method}`, log);
    }
  }

  /**
   * Method to handle handleOpenSuccess - overriden by Livechat SDK method
   * @param session : Session related data received from livechat if OpenSuccess
   */
  handleOpenSuccess = (session: any) => {
    try {
      if (
        this.startService.areQueryParametersChanged &&
        this.appConfig?.Miscellaneous?.confirmationOnQueryParamChange
      ) {
        this.confirmDialog(
          this.appLabels?.globalLabels?.queryChangeConfirmationMessage ??
            `Query change detected. Do you want to end the session and start again?`,
          '',
          (result) => {
            if (result) {
              this.snackBar.open(
                this.appLabels?.globalLabels?.queryChangeMessage ?? `Query has been changed. Restarting session..`,
                'Dismiss',
                {
                  duration: 3000,
                  horizontalPosition: this.snackbarHorizontalPosition,
                  verticalPosition: this.snackbarVerticalPosition,
                  panelClass: ['mat-toolbar']
                }
              );
              this.commInterface.end('Query parameters changed', '');
              return;
            }
          }
        );
      } else if (this.startService.areQueryParametersChanged) {
        this.snackBar.open(
          this.appLabels?.globalLabels?.queryChangeMessage ?? `Query has been changed. Restarting session..`,
          'Dismiss',
          {
            duration: 3000,
            horizontalPosition: this.snackbarHorizontalPosition,
            verticalPosition: this.snackbarVerticalPosition,
            panelClass: ['mat-toolbar']
          }
        );
        this.commInterface.end('Query parameters changed', '');
        return;
      }
      this.messengerService.LivechatStatus = this.appConfig.CommunicationInterface?.activeLiveChat +
      ' ' + 'OpenSuccess: ';
      this.livechatStatus = this.messengerService.LivechatStatus;
      if (
        $b.GetLocalStorage('chatActive') === null ||
        $b.GetLocalStorage('chatActive') == 'false' ||
        ($b.GetSessionStorage('Initial Load') && $b.GetLocalStorage('chatActive') == 'true')
      ) {
        if (session.trans && session.trans.length > 0) {
          // For considering session data as delivered [to prevent from adding to unsentmessages array in livechatcomponent]
          this.messengerService.repeatedSession = true;
          session.trans.forEach((element) => {
            if (element.type === 'livechat2') {
              // ignore
            } if (element.type === 'connect') {
              this.handleRemoteUserConnected(element.name, element.id, session.sid_webapi, null);
            } else if (element.type === 'disconnect') {
              this.handleConferenceUserLeft(element.id, element.time, '');
            } else {
              if (this.who === '' || this.who === 'bot') {
                if (element.by !== 'c' || this.appConfig?.chatBot?.enabled) {
                  const msg = decodeURIComponent(element.msg);
                  this.handleMessageReceivedEvent(element.by, msg, element.time, '');
                }
              } else {
                const msg = decodeURIComponent(element.msg);
                this.handleMessageReceivedEvent(element.by, msg, element.time, '');
              }
            }
          });
        this.messengerService.repeatedSession = false;
        } else {
          this.snackBar.open(`No session available.`, 'Dismiss', {
            duration: 3000,
            horizontalPosition: this.snackbarHorizontalPosition,
            verticalPosition: this.snackbarVerticalPosition,
            panelClass: ['mat-toolbar']
          });
          this.commInterface.end('No Session Available', '');
        }
      }
      this.sessionId = session?.sid_tchat?.split('_')?.[1] ?? '';
    } catch (error) {
      console.error('%c Error Occured in handleOpenSuccess', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleOpenSuccess', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.handleOpenSuccess', JSON.stringify(error));
    }
  };

  /**
   * Method to handle handleOpenFailed - overriden by Livechat SDK method
   * @param retCode : Return code sent from livechat SDK based on OpenFailed error.
   */
  handleOpenFailed = (retCode: string) => {
    try {
      this.messengerService.LivechatStatus = this.appConfig.CommunicationInterface?.activeLiveChat +
      ' ' + 'OpenFailed: ' + retCode;
      this.livechatStatus = this.messengerService.LivechatStatus;
      // Upon manual cookie clearing, sessionstarted key will be true. In this case, trigger permission check here (not in ngOnInit)
      if (this.appConfig?.permissionsConfig?.enableRestriction && !this.isPermissionDialogTriggered)
        this.getDevicePermissions();
      else
      this.commInterface.logToServer(
        'info',
        'AppComponent.handleOpenFailed',
        `Skipping device permission check as enableRestriction - ${this.appConfig?.permissionsConfig?.enableRestriction}, dialog triggered - ${this.isPermissionDialogTriggered}`
      );
      if (retCode === 'NoSessionFound') {
        if(this.appConfig?.CommunicationInterface?.activeLiveChat === 'livechat2') {
          this.tokenReceived = true;
        }
        this.commInterface.accessToken();
        this.commInterface.sessionTokenObservable.subscribe((tokenMsg) => {
          this.tokenReceived = true;
          console.log('tokenMsg', tokenMsg);
          if (tokenMsg.successMsg) {
            this.log('Info', 'handleOpenFailed.GetAccessToken', tokenMsg.successMsg, true);
            $b.SetSessionStorage('token', tokenMsg.successMsg);
            this.isCaptchaLoaded = false;
            console.log("isCaptchaEnabled", this.isCaptchaEnabled);

            
          } else if (tokenMsg.errorMsg) {
            this.log('error', 'handleOpenFailed.GetAccessToken', tokenMsg.errorMsg, true);
          }
          // Check if Captcha is Enabled and route to captcha
          if (this.isCaptchaEnabled === true) {
            setTimeout(() => {
              this.zone.run(() => {
                this.route.navigate(['captcha'], {
                  queryParams: { ...this.startService.queryParameters },
                  queryParamsHandling: 'preserve'
                });
              });
            }, 100);
          } else {
            // this.startService.checkforLivechatStart('');
          }
        });
      } else if (retCode === 'CookiesDisabled') {
        this.log('error', 'handleOpenFailed', 'Please enable browser cookies', true);
      } else if (retCode === 'AlreadyEndedSession') {
        this.sessionStarted = false;
        $b.RemoveLocalStorage('appconfig'); // remove the app-config stored in the localstorage
        $b.SetLocalStorage('chatActive', false);
        const navigationExtras: NavigationExtras = {
          queryParamsHandling: 'preserve',
          preserveFragment: true,
          queryParams: { ...this.startService.queryParameters },
          state: { reload: true }
        };
        this.zone.run(() => {
          this.route.navigate(['/'], navigationExtras);
        });
        setTimeout(() => {
          location.reload();
        }, 1000);
      } else if (retCode === 'RequestFailed') {
        this.snackBar.open(`No Internet Connection`, 'Dismiss', {
          duration: 4000,
          horizontalPosition: this.snackbarHorizontalPosition,
          verticalPosition: this.snackbarVerticalPosition,
          panelClass: ['custom-snackbar']
        });
        const timeoutDuration = this.appConfig?.timeoutDurations?.requestFailed
          ? this.appConfig.timeoutDurations.requestFailed
          : 10000;
        setTimeout(() => {
          this.commInterface.open();
        }, timeoutDuration);
      } else {
        this.sessionStarted = false;
        $b.SetSessionStorage('sessionStarted', false);
      }
    } catch (error) {
      console.error('%c Error Occured in handleOpenFailed', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleOpenFailed', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.handleOpenFailed', JSON.stringify(error));
    }
  };

  
  /**
   * Method to handle captcha expiration
   */
  handleCaptchaExpiry = () => {
    try
    {
        // if ($b.GetSessionStorage('sessionStarted') === null) 
        {
          // this.commInterface.end('Session Timed Out', '');
          // const navigationExtras: NavigationExtras = {
          //   queryParamsHandling: 'preserve',
          //   preserveFragment: true,
          //   queryParams: { ...this.startService.queryParameters },
          //   state: { reload: true }
          // };

          
              // [MS: Sep 13, '21] route to custom static page if configured
              // if (this.appConfig?.Miscellaneous?.CustomStartPageUrl) {
              //   location.href = this.appConfig?.Miscellaneous?.CustomStartPageUrl + location.search;
              // } else {
              //   // Navigate to thank-you page if ThankyoupageEnabled
              //   if (this.appConfig.Miscellaneous.ThankyoupageEnabled) {
              //     this.zone.run(() => {
              //       this.route.navigate(['/thank-you'], navigationExtras);
              //     });
              //   } else {
              //     // Navigate to main page if captcha is enabled
              //     if (this.isCaptchaEnabled === true) {
              //       this.zone.run(() => {
              //         this.route.navigate(['/'], navigationExtras);
              //       });
              //     } else {
              //       this.zone.run(() => {
              //         this.route.navigate(['/'], navigationExtras);
              //       });
              //     }
              //   }
              // }

        this.confirmDialog(
        this.appLabels?.globalLabels?.sessionTimeoutReloadingMessage ?? 
          `Captcha Timed Out! Click ok to regenerate..`,
          JSON.stringify({ singleAction: true }),
        (result) => {
          if(result)
          {
            location.reload()
          }
          else
          {
          this.handleCaptchaExpiry();
          }
        }
        );
        }
    } catch (error) {
          console.error('Exception in AppComponent.handleCaptchaExpiry', error);
          this.commInterface.sendUIErrors('AppComponent', 'handleCaptchaExpiry', error);
        }
      
  }




  /**
   * Method to handle handleStartSuccess - overriden by Livechat SDK method
   */
  handleStartSuccess = (params?: any) => {
    try {
      this.appDataService.logPackagesToServer();
      this.messengerService.LivechatStatus = 'StartSucess';
      this.livechatStatus = this.messengerService.LivechatStatus;
      this.sessionStarted = true;
      console.log('session start triggered');
      $b.SetSessionStorage('sessionStarted', true);
      this.initiateDuplicateWindowListener();
      this.sessionId = params?.tChatId?.split('_')?.[1];
    } catch (error) {
      console.error('%c Error Occured in handleStartSuccess', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleStartSuccess', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.handleStartSuccess',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to handle handleInternalServerError - overriden by Livechat SDK method
   * @param errorCode : Error code value sent from livechat incase of Internal Server Error
   */
  handleInternalServerError = (errorCode) => {
    try {
      this.messengerService.LivechatStatus = 'InternalServerError';
      this.livechatStatus = this.messengerService.LivechatStatus;
      this.snackBar.open(`Internal Server Error - Closing Session`, 'Dismiss', {
        duration: 3000,
        horizontalPosition: this.snackbarHorizontalPosition,
        verticalPosition: this.snackbarVerticalPosition,
        panelClass: ['mat-toolbar']
      });
      this.commInterface.end('Internal Server Error', '');
      if (errorCode === 'UnOpenedSessionNotAllowed') {
        this.reloadandReturn();
      }
    } catch (error) {
      console.error('%c Error Occured in handleInternalServerError', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleInternalServerError', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.handleInternalServerError',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to handle handleStartFailed - overriden by Livechat SDK method
   * @param code : Code sent from livechat SDK on startfailed.
   */
  handleStartFailed = (code: string) => {
    try {
      this.messengerService.LivechatStatus = this.appConfig.CommunicationInterface?.activeLiveChat +
      ' ' + 'StartFailed';
      this.livechatStatus = this.messengerService.LivechatStatus;
      if (code === 'AlreadyStartedAndInSession') {
        // this.reloadandReturn();
        this.handleStartSuccess();
      } else if (
        code === 'UnOpenedSessionPerformedStart' ||
        code === 'StartError' ||
        code === 'ServerInternalConnectivityError' ||
        code === 'AlreadyEndedSession'
      ) {
        this.reloadandReturn();
      } else if (code === 'RequestFailed') {
        this.snackBar.open(`No Internet Connection`, 'Dismiss', {
          duration: 4000,
          horizontalPosition: this.snackbarHorizontalPosition,
          verticalPosition: this.snackbarVerticalPosition,
          panelClass: ['custom-snackbar']
        });
        const timeoutDuration = this.appConfig?.timeoutDurations?.requestFailed
          ? this.appConfig.timeoutDurations.requestFailed
          : 10000;
        setTimeout(() => {
          // this.startService.checkforLivechatStart('');
        }, timeoutDuration);
      } else if (code === 'LicenseExpired') {
        this.confirmDialog(
        this.appLabels?.globalLabels?.licenseExpiredMessage ,
        JSON.stringify({ singleAction: true }),
        (result) => {
          if(result) {
         location.reload();
          }});
        return;
  } else {
        if (code == 'MaxConcurrentSessionCountReached') {
          this.snackBar.open(
            this.appLabels?.globalLabels?.maxConcurrentSessionCountReachedMessage ?? `Maximum session count reached!`,
            'Dismiss',
            {
              duration: 4000,
              horizontalPosition: this.snackbarHorizontalPosition,
              verticalPosition: this.snackbarVerticalPosition,
              panelClass: ['custom-snackbar']
            }
          );
        }
        // Check if Captcha is Enabled
        if (this.isCaptchaEnabled === true) {
          setTimeout(() => {
            this.zone.run(() => {
              this.route.navigate(['captcha'], {
                queryParams: { ...this.startService.queryParameters },
                queryParamsHandling: 'preserve'
              });
            });
          }, 100);
        } else {
          // this.startService.checkforLivechatStart('');
        }

        this.eventBus.emitEventListeners('SessionStartFailed', { code });
      }
    } catch (error) {
      console.error('%c Error Occured in handleStartFailed', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleStartFailed', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.handleStartFailed', JSON.stringify(error));
    }
  };

  /**
   * Method to handle handleRemoteUserConnected - overriden by Livechat SDK method
   * @param name : Name of the Agent.
   * @param agentId : ID of the Agent.
   * @param sessionID : Session ID of the current Session.
   * @param extraParam : Extra params sent if any for particular Agent.
   */
  handleRemoteUserConnected = (name: string, agentId: string, sessionID: string, extraParam) => {
    try {
      this.queueSnackBarRef?.dismiss();
      this.isLoading = false;
      this.messengerService.LivechatStatus = 'RemoteUserConnected';
      this.queueService.isRemoteUserConnected = true;
      this.queueService.setQueueStatus(false);
      this.livechatStatus = this.messengerService.LivechatStatus;
      // if the extra parameter is there, then store to session storage for that agent
      if (extraParam) {
        $b.SetSessionStorage('a_' + agentId, extraParam);
      }

      // define the details
      let details = null;

      // get the agent details from the storage or extra params
      const jsonData = $b.GetSessionStorage('a_' + agentId) || (typeof extraParam !== 'undefined' ? extraParam : null);

      // parse the data if available
      details = jsonData ? JSON.parse(jsonData) : null;

      // check if the details available, else handle in legacy way
      if (details && details.agentType) {
        // check the agent type is 'chatbot'
        if (details.agentType === 'Chatbot') {
          // assign the who
          this.who = 'bot';
          console.log('%c handleRemoteUserConnected - Initial connect, This is a bot!', 'color: #f143cc');
          this.commInterface.logToServer(
            'info',
            'AppComponent.handleRemoteUserConnected',
            'Initial connect. Might be a bot - 1'
          );
          // push the agent to agent list in messenger service
          const botDetail = { type: 'bot', agentId, agentName: name, agentTheme: '' };
          const isAgentAlreadyPresent = this.messengerService.agentList.find((agent) => {
            return agent.agentId == agentId;
          });
          
        // this.queueService.setQueueStatus(false);
          if (!isAgentAlreadyPresent) {
            this.messengerService.agentList.push(botDetail);
            this.messengerService.handleConferenceUsers(this.messengerService.agentList);

            if (this.appConfig?.chatBot?.enabled) {
              const navigationExtras: NavigationExtras = {
                queryParamsHandling: 'preserve',
                queryParams: { details, ...this.startService.queryParameters },
                state: { agent: botDetail }
              };
              setTimeout(() => {
                this.zone.run(() => {
                  this.route.navigate(['chat'], navigationExtras);
                });
              }, 100);
              // this.eventBus.emitEventListeners(eventName, jsonMessage);
            }
          }
        }
        // this can be a connect without bot or a connect after bot or after queue so assign to agent
        else if (this.who === '' || this.who === 'bot' || this.who === 'queue') {
          this.who = 'agent';
          console.log('%c handleRemoteUserConnected - Agent connected', 'color: #f143cc');
          this.commInterface.logToServer('info', 'AppComponent.handleRemoteUserConnected', 'Agent connected');

          // update the agent list
          const isAgentAlreadyPresent = this.messengerService.agentList.findIndex((agent) => {
            return agent.agentId == agentId;
          });
          if (isAgentAlreadyPresent < 0) {
            this.UserConnectednavigationExtras = {
              queryParamsHandling: 'preserve',
              preserveFragment: true,
              queryParams: { ...this.startService.queryParameters },
              state: {
                data: name,
                user: { type: 'agent', agentId, agentName: name, agentTheme: this.defaultFirstAgentTheme }
              }
            };
  
            this.existingAgent = this.UserConnectednavigationExtras;
  
            // update livechat user list
            this.messengerService.userChanged(this.UserConnectednavigationExtras);
  
            // route to chat component
            setTimeout(() => {
              this.zone.run(() => {
                this.route.navigate(['chat'], this.UserConnectednavigationExtras);
              });
            }, 100);
            
            this.messengerService.agentList.push({ type: 'agent', agentId, agentName: name, agentTheme: '' });
            this.assignAgentTheme();
            this.messengerService.handleConferenceUsers(this.messengerService.agentList);
          }
        } else {
          // this can be when an agent already connected and conference agent connects
          this.who = 'cAgent';

          console.log('%c handleRemoteUserConnected - Conference agent connected', 'color: #f143cc');
          this.commInterface.logToServer(
            'info',
            'AppComponent.handleRemoteUserConnected',
            'Conference agent connected - 1'
          );

          // push the agent to agent list in messenger service
          if (this.messengerService.agentList.length === 0) {
            this.messengerService.agentList.push({ type: 'agent', agentId, agentName: name, agentTheme: '' });
          } else {
            let isAgentAlreadyAvailable = false;
            this.messengerService.agentList.forEach((x) => {
              if (x.agentId == agentId && !isAgentAlreadyAvailable) {
                isAgentAlreadyAvailable = true;
                return;
              }
            });
            if (!isAgentAlreadyAvailable)
              this.messengerService.agentList.push({ type: 'agent', agentId, agentName: name, agentTheme: '' });
          }

          this.assignAgentTheme();
          this.messengerService.handleConferenceUsers(this.messengerService.agentList);
        }
        return;
      }

      this.legacy = true;

      // check if this is the first agent connect to chat
      // this can be bot/agent in legacy mode
      // we blindly assign the who to 'agent'
      // later if its a bot, the who will be changed to 'bot' in ChatBotStartEvent
      if (this.who === '') {
        console.log('%c handleRemoteUserConnected - Initial connect, This can be a bot too!', 'color: #f143cc');
        this.commInterface.logToServer(
          'info',
          'AppComponent.handleRemoteUserConnected',
          'Initial connect. Might be a bot! - 2'
        );
        this.who = 'agent';
        this.messengerService.agentList.push({ type: 'agent', agentId, agentName: name, agentTheme: '' });
        this.assignAgentTheme();
        this.messengerService.handleConferenceUsers(this.messengerService.agentList);
        this.zone.run(() => {
          this.route.navigate(['chat'], {
            queryParamsHandling: 'preserve',
            preserveFragment: true,
            queryParams: { ...this.startService.queryParameters }
          });
        });
      } else if (this.who === 'bot' || this.who === 'queue') {
        console.log('%c handleRemoteUserConnected - First agent connected', 'color: #f143cc');
        this.who = 'agent';
        const firstMessage = name;
        console.log(firstMessage);
        this.commInterface.logToServer('info', 'AppComponent.handleRemoteUserConnected', 'First agent connected');

        const navigationExtras: NavigationExtras = {
          queryParamsHandling: 'preserve',
          preserveFragment: true,
          queryParams: { ...this.startService.queryParameters },
          state: { data: firstMessage }
        };

        this.messengerService.agentList.push({ type: 'agent', agentId, agentName: name, agentTheme: '' });
        this.assignAgentTheme();
        this.messengerService.handleConferenceUsers(this.messengerService.agentList);

        setTimeout(() => {
          this.zone.run(() => {
            this.route.navigate(['chat'], navigationExtras);
          });
        }, 100);
      } else {
        // this can be when an agent already connected and conference agent connects
        this.who = 'cAgent';
        console.log('%c handleRemoteUserConnected - Conference agent connected', 'color: #f143cc');
        this.commInterface.logToServer(
          'info',
          'AppComponent.handleRemoteUserConnected',
          'Conference agent connected - 2'
        );
        this.messengerService.agentList.push({ type: 'agent', agentId, agentName: name, agentTheme: '' });
        this.assignAgentTheme();
        this.messengerService.handleConferenceUsers(this.messengerService.agentList);
      }
      this.queueService.updateQueueHF([], []);
    } catch (error) {
      console.error('%c Error Occured in handleRemoteUserConnected', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleRemoteUserConnected', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.handleRemoteUserConnected',
        JSON.stringify(error)
      );
    }
  };

   /**
   * Method to handle handleUserJoining - overriden from Livechat SDK methods
   * @param agent : Agent ID who has joined the conference.
   */
   handleUserJoining = (agent: string) => {
    try {
      this.messengerService.LivechatStatus = 'UserJoining';
      this.livechatStatus = this.messengerService.LivechatStatus;
      console.log("handleUserJoining:", agent)
    } catch (error) {
      console.error('%c Error Occured in handleUserJoining', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleUserJoining', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.handleUserJoining',
        JSON.stringify(error)
      );
    }
  };


  /**
   * Method to handle handleConferenceUserLeft - overriden from Livechat SDK methods
   * @param agent : Agent ID who has left the conference.
   * @param reason : Reason due to which Agent has left.
   */
  handleConferenceUserLeft = (agent: string, time:string, reason: string) => {
    try {
      this.messengerService.LivechatStatus = 'ConferenceUserLeft';
      this.livechatStatus = this.messengerService.LivechatStatus;
      let connectedAgents = this.messengerService.agentList;

      let who = 'cAgent';
      const AgentName = connectedAgents.filter((a) => a.agentId === agent)[0].agentName;
      const Type = connectedAgents.filter((a) => a.agentId === agent)[0].type;

      const disconnectedAgent = { agentID: agent, agentName: AgentName, type: Type };
      this.messengerService.handleConnectedUserLeft(disconnectedAgent);
      if (Type === 'agent') {
        
        const message =
        this.appLabels?.liveChatComponent
        ?.agentLeftConferenceMessage?.replace('**agent**', AgentName ?? 'Agent') ??
        `${AgentName ?? 'Agent'} has left the conference!`;

        // Don't show toaster for history data on refresh
        if(!this.messengerService.repeatedSession) {          

          this.snackBar.open(message, 'Dismiss', {
            duration: 3000,
            horizontalPosition: this.snackbarHorizontalPosition,
            verticalPosition: this.snackbarVerticalPosition
          });
        }

      }

      connectedAgents = connectedAgents.filter((a) => a.agentId !== agent);
      if (connectedAgents && connectedAgents.length <= 2) {
        // if the bot is disconnected after agent transfer and if agent do a blind transfer to queue
        // there will be no agent connected at that time give last agent name as header label and who as queue
        if (connectedAgents.length === 0) {
          who = 'queue';
          // if there are 3 agents including bot, then if an agent leave then change the header label and who reference
          // else let it header label as 'Conference' and who as 'cAgent' only
        } else {
          // set the 'who' as type of last connected agent
          who = connectedAgents[connectedAgents.length - 1].type;
        }
      }
      this.who = who;
      this.messengerService.agentList = connectedAgents;
      setTimeout(() => {
        this.messengerService.handleConferenceUsers(this.messengerService.agentList);
      }, 1000);
      $b.RemoveSessionStorage('a_' + agent);
    } catch (error) {
      console.error('%c Error Occured in handleConferenceUserLeft', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleConferenceUserLeft', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.handleConferenceUserLeft',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to handle handleCallbackAutoRegistered coming from livechat SDK
   * @param reasonCode : Reason code for CallBackAutoRegistered.
   */
  handleCallbackAutoRegistered = (reasonCode: string) => {
    try {
      if (reasonCode == 'TimedOutInQueue') {
        this.snackBar.open(
          this.appLabels?.globalLabels?.timedOutInQueueMessage ?? `Session timed out in queue`,
          'Dismiss',
          {
            duration: 4000,
            horizontalPosition: this.snackbarHorizontalPosition,
            verticalPosition: this.snackbarVerticalPosition,
            panelClass: ['custom-snackbar']
          }
        );
      }
      this.commInterface.end(`Callback AutoRegistered : ${reasonCode} `, '');
      this.reloadandReturn();
    } catch (error) {
      console.error('%c Error Occured in handleCallbackAutoRegistered', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleCallbackAutoRegistered', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.handleCallbackAutoRegistered',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to handle handleTypingStateChanged coming from livechat SDK
   * @param agent : Agent ID/Name who is typing
   * @param stat : Typing status of the Agent
   */
  handleTypingStateChanged = (agent: string, state: number) => {
    try {
      this.messengerService.sendAgentTypingStatus({ agent, state });
    } catch (error) {
      console.error('%c Error Occured in handleTypingStateChanged', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleTypingStateChanged', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.handleTypingStateChanged',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to handle AppMessageEvent coming from livechat SDK
   * @param agent : Agent Name / ID
   * @param message : App message being sent from TMAC/AD as JSON string
   * @param id : App Message ID
   */
  handleAppMessageEvent = (agent: string, message: string, id: string) => {
    try {
      const appmessage = JSON.parse(message);
      if (appmessage.type === 'conferenceConnected') {
        this.handleRemoteUserConnected(appmessage.data.agentName, appmessage.data.agentId, '', '');
      } else if (appmessage.type === 'conferenceDisconnected') {
        this.handleConferenceUserLeft(appmessage.data.agentId, '', '');
      }
      this.messengerService.LivechatStatus = 'AppMessageRecieved';
      this.livechatStatus = this.messengerService.LivechatStatus;
      console.log('AppMessage: ', { agent, id, message });
      this.messengerService.appMessageReceived({ agent, id, message });
    } catch (error) {
      console.error('%c Error Occured in handleAppMessageEvent', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleAppMessageEvent', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.handleAppMessageEvent',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to handle OnMessageReceived Event
   * @param agent : Agent Name / ID or Bot
   * @param message : ChatBot messages
   * @param id : Message Received Event ID
   */
  handleMessageReceivedEvent = (agent: string, message: string, time: string, id: string) => {
    this.commInterface.clearConnectionTimeoutTimer();
    this.messengerService.LivechatStatus = 'OnMessageReceived';
    this.livechatStatus = this.messengerService.LivechatStatus;
    try {

      if(this.appConfig?.LivechatComponent?.ignoreMessages) {
      let parsedMessage: any = null;

      // ✅ Parse the message if it's a valid JSON string
      if ($b.IsValidJson(message)) {
        parsedMessage = $b.JParse(message);
      }

      // ✅ Proceed only if agent exists and message ID is undefined
      if (agent && id === undefined) {
        // Extract the actual message text (from JSON or plain string)
        const messageText = parsedMessage?.message || message;

        // Message format for "Call Ended Successfully" in both livechat are different as below: 
        // LC1:  {"templateId":null,"message":"Call Ended Successfully","attachment":null} 
        // LC2: "Call Ended Successfully"

        // ✅ If the extracted message text is in the ignored list, skip further processing
        if (
          typeof messageText === 'string' &&
          this.appConfig?.LivechatComponent?.ignoredMessagesList.includes(messageText)
        ) {
              console.log("Ignored message: ", message, "with agentid: ", agent)
              return;
            }
          }
      }
      const chatRefreshCondition = $b.IsValidJson(message) && !$b.JParse(message).messageId && agent !== 'c';
      if ((!this.legacy && this.who === 'bot') || (this.legacy && $b.IsValidJson(message) && chatRefreshCondition)) {
        const jsonMessage = $b.JParse(message);

        try {
          console.log(jsonMessage);
          let methodName = jsonMessage.EventName;
          console.log("methodName", methodName);
          if (this[methodName]) {
            this.commInterface.logToServer(
              'info',
              'AppComponent.handleMessageReceivedEvent',
              `Method name: ${methodName}`
            );
            switch (methodName) {
              case 'ChatBotActionEvent':
                this[methodName](jsonMessage);
                break;
              default:
                this[jsonMessage.EventName](agent, jsonMessage, 'new', false);
                break;
            }
          }
        } catch (error) {
          console.error('%c Error Occured in handleMessageReceivedEvent.methodName', 'color: red', error);
          this.commInterface.sendUIErrors(
            'AppComponent',
            'handleMessageReceivedEvent.methodName',
            JSON.stringify(error)
          );
          this.commInterface.logToServer(
            'error',
            'Error occured in AppComponent.handleMessageReceivedEvent.methodName',
            JSON.stringify(error)
          );
        }

        if (jsonMessage?.NodeType) {
          let eventName = 'MessageEvent';
          let url = '';
          let state = { data: JSON.stringify(jsonMessage), headerFooter: '' };
          switch (jsonMessage.NodeType) {
            case 'HF':
              eventName = 'HeaderFooterEvent';
              $b.SetSessionStorage('headerFooter', JSON.stringify(jsonMessage));
              $b.SetSessionStorage('SessionId', jsonMessage.SessionId);
              break;
            case 'PROMPT':
              eventName = 'AnnouncementEvent';
              url = 'announcement';
              break;
            case 'MENU':
              eventName = 'MenuEvent';
              url = 'menu';
              state = { data: JSON.stringify(jsonMessage), headerFooter: $b.GetSessionStorage('headerFooter') };
              break;
            case 'FORM':
              eventName = 'FormEvent';
              url = 'forms';
              break;
            case 'PNC':
              eventName = 'PNCEvent';
              url = 'pnc';
              break;
            case 'ACTION':
              eventName = 'ActionEvent';

              if (jsonMessage.EventName === 'QueuePosition') {
                this.queueService.updateQueueNumberandImage(
                  jsonMessage?.Text,
                  jsonMessage?.Image,
                  jsonMessage?.OtherData,
                  jsonMessage?.AgentTransferText,
                  jsonMessage?.QueuePositionSettings
                );
              }
              break;
            default:
              eventName = 'MessageEvent';
              console.log(jsonMessage);
              break;
          }
          this.commInterface.logToServer(
            'info',
            'AppComponent.handleMessageReceivedEvent',
            'JSON message' + JSON.stringify(jsonMessage)
          );
          // if url is there and chatbot not enabled then route
          if (url && !this.appConfig?.chatBot?.enabled && !this.messengerService.isLiveAgentConnected && this.who != 'agent') {
            const navigationExtras: NavigationExtras = {
              queryParamsHandling: 'preserve',
              preserveFragment: true,
              queryParams: { ...this.startService.queryParameters },
              state
            };
            this.zone.run(() => {
              this.route.navigate([url], navigationExtras);
            });
          }
          console.log(Date.now(), "HandleMessageReceivedEvent: before setActiveNode: ",
            JSON.stringify(jsonMessage) );
          this.commInterface.logToServer(
              'info',
              'AppComponent.handleMessageReceivedEvent',
              'before setActiveNode:' + JSON.stringify(jsonMessage)
            );

            this.commInterface.logToServer("this.who, isLiveAgentConnected",
              this.who, this.messengerService.isLiveAgentConnected.toString()
            );

          // if chatbot enabled and message is from a valid node then process the message
          if (
            (this.appConfig?.chatBot?.enabled || this.who == 'agent' 
              || this.messengerService.isLiveAgentConnected) &&
            jsonMessage?.NodeType !== 'HF' &&
            jsonMessage?.NodeType !== 'ACTION' &&
            jsonMessage.EventName !== 'QueuePosition' &&
            jsonMessage.NodeType !== 'ChatbotSelfServiceEndedEvent'
          ) {
            this.messengerService.setActiveNode(jsonMessage);
            console.log("HandleMessageReceivedEvent: after setActiveNode: ",
              JSON.stringify(jsonMessage) );
            this.commInterface.logToServer(
                'info',
                'AppComponent.handleMessageReceivedEvent',
                'after setActiveNode:' + JSON.stringify(jsonMessage)
              );
            
              
            this.generateMessageToProcess(jsonMessage, time, agent);
          }
          // emit the events for subscribers
          this.eventBus.emitEventListeners(eventName, jsonMessage);
        } else if (this.messengerService.agentList.length) {
          const isAgentPresent = this.messengerService.agentList.find((listAgent) => {
            return listAgent.agentId == agent;
          });
          if (isAgentPresent) {
            this.handleAgentMessages(agent, message, time);
          }
        }
        // following condition added to process customer selected / submitted msgs with bot when browser refreshed
        if (
          agent === 'c' &&
          this.appConfig?.chatBot?.enabled &&
          $b.GetSessionStorage('Initial Load') >= 1 &&
          jsonMessage?.NodeType !== 'ACTION'
        ) {
          const jsonMessage = $b.JParse(message);
          this.generateMessageToProcess(jsonMessage, time, agent);
        }
      }
      // else its an agent message
      else if (this.who === 'agent' || this.who === 'cAgent') {
        const jsonMessage = $b.JParse(message);
        if (jsonMessage?.NodeType !== 'ACTION') this.handleAgentMessages(agent, message, time);
      } else if (agent === 'c' && this.appConfig?.chatBot?.enabled 
      && $b.GetSessionStorage('Initial Load') >= 1) {
        const jsonMessage = $b.JParse(message);
        if (jsonMessage?.NodeType !== 'ACTION') this.generateMessageToProcess(jsonMessage, time, agent);
      }
    } catch (error) {
      console.error('%c Error Occured in handleMessageReceivedEvent', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleMessageReceivedEvent', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.handleMessageReceivedEvent',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to handle Agent messages from livechat
   * @param agent : Agent details
   * @param message : Message text
   * @param id : ID for individual message
   * @param messagetype : Agent Message Type
   * @param status : Message Status
   */
  handleAgentMessages = (agent, message, time) => {
    try {
      this.isLoading = false;
      // Dismiss queue snackbar if shown
      if (this.queueSnackBarRef) {
      this.queueSnackBarRef.dismiss();
      this.queueSnackBarRef = null;
      }
      this.messengerService.LivechatStatus = 'AgentMessageRecieved';
      this.livechatStatus = this.messengerService.LivechatStatus;
      const msgBy = this.messengerService.agentList.filter((a) => a.agentId === agent)[0];
      let AgentTheme;
      if (msgBy === undefined) {
        AgentTheme = '$primary';
      } else {
        AgentTheme = msgBy.agentTheme;
      }    const msg = {
        deliveredToServer: this.messengerService.repeatedSession,
        message,
        by: {
          id: agent,
          name: msgBy ? msgBy.agentName : agent === 'c' ? 'You' : this.appLabels?.globalLabels?.defaultSenderName ?? 'Chatbot',
          agentTheme: AgentTheme
        },
        time: time
      }
      this.messengerService.agentMessageReceived(msg);
    } catch (error) {
      console.error('%c Error Occured in handleAgentMessages', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleAgentMessages', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.handleAgentMessages',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to handle livechat OnEnd event
   * @param initiator : client/server
   * @param reason : Reason to end the call
   */
  handleOnEnd = (initiator: string, reason: string) => {
    try {
      // console.log('%c handleOnEnd: ' + initiator + ' - ' + reason, 'color: cyan');
      sessionStorage.clear();
      this.messengerService.LivechatStatus = 'OnEnd';
      this.snackBar.open(this.appLabels?.liveChatComponent?.sessionEndMessage ?? `Session has been ended!`, 'Dismiss', {
        duration: 3000,
        horizontalPosition: this.snackbarHorizontalPosition,
        verticalPosition: this.snackbarVerticalPosition,
        panelClass: ['mat-toolbar']
      });
      this.livechatStatus = this.messengerService.LivechatStatus;
      this.queueService.stopQueueAudio();
      if (initiator === 'lib' && reason === 'SessionLostWhileOffline') {
        this.snackBar.open(`Session Lost, Connecting again...`, 'Dismiss', {
          duration: 3000,
          horizontalPosition: this.snackbarHorizontalPosition,
          verticalPosition: this.snackbarVerticalPosition,
          panelClass: ['mat-toolbar']
        });
      }
      console.log("Initiator: Reason", initiator + ": " + reason);;
      if (initiator === 'server' && ['disconnect', 'OnDisconnect'].includes(reason)) {
        initiator = 'client';

        this.snackBar.open(this.appLabels?.globalLabels?.serverConnectionTimeoutMessage ??
          `Lost connection to server`, 'Dismiss', {
          duration: 5000,
          horizontalPosition: this.snackbarHorizontalPosition,
          verticalPosition: this.snackbarVerticalPosition,
          panelClass: ['mat-toolbar']
        });
      }
      this.onEndRedirection(initiator);
    } catch (error) {
      console.error('%c Error Occured in handleOnEnd', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleOnEnd', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.handleOnEnd', JSON.stringify(error));
    }
  };

  /**
   * Method to handle app redirection after session end based on app configurations
   * @param initiator Client / Server
   */
  onEndRedirection = (initiator?) => {
    try {
      this.sessionStarted = false;
      sessionStorage.clear();
      $b.RemoveLocalStorage('appconfig');
      $b.SetLocalStorage('chatActive', false);
      $b.SetLocalStorage('postInteractionSurvey', false);
      this.commInterface.notifyEndOfSession(initiator);

      if (!this.appConfig?.disableRedirectionOnEnd || initiator === 'client') {
        setTimeout(() => {
          this.commInterface.logToServer('info', 'AppComponent.onEndRedirection', 'Redirecting');
          const navigationExtras: NavigationExtras = {
            queryParamsHandling: 'preserve',
            preserveFragment: true,
            queryParams: { ...this.startService.queryParameters },
            state: { reload: true }
          };

          if (this.appConfig?.Miscellaneous?.CustomStartPageUrl) {
            location.href = this.appConfig?.Miscellaneous?.CustomStartPageUrl + location.search;
          } else {
            if (this.appConfig.Miscellaneous.ThankyoupageEnabled) {
              this.zone.run(() => {
                this.route.navigate(['/thank-you'], navigationExtras);
              });
            } else {
              if (this.isCaptchaEnabled === true) {
                this.zone.run(() => {
                  this.route.navigate(['/'], navigationExtras);
                });
              } else {
                this.zone.run(() => {
                  this.route.navigate(['/'], navigationExtras);
                });
              }
            }
          }
        }, 1000);
      }
    } catch (error) {
      console.error('%c Error Occured in onEndRedirection', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'onEndRedirection', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.onEndRedirection', JSON.stringify(error));
    }
  };

  /**
   * Method to handle call queued event
   * @param queuePos Queue position
   * @param queueType Queue type
   */
  handleCallQueued = (queuePos: number, queueType: string) => {
    let availableQueueTypes = this.appConfig?.ChatQueueComponent?.availableQueueTypes;
    availableQueueTypes = availableQueueTypes ? availableQueueTypes.split(',') : ['2', '3'];

    try {
      this.isLoading = false;
      // Dismiss existing snackbar if already shown
      if(this.appLabels.globalLabels?.queueMessage) {
        this.queueSnackBarRef = this.snackBar.open(
        this.appLabels.globalLabels?.queueMessage ?? 'Session is in queue and will be redirected to agent/bot',
        'Dismiss',
        {
        horizontalPosition: this.snackbarHorizontalPosition,
        verticalPosition: this.snackbarVerticalPosition,
        duration: -1,  // stays open until dismissed
        panelClass: ['custom-snackbar'],
        }
        );
      }

      this.messengerService.LivechatStatus = 'OnCallQueued';
      this.queueService.isRemoteUserConnected = false;
      if (queuePos && queuePos > 0 && queueType && availableQueueTypes.includes(queueType)) {
      }

      if (availableQueueTypes.includes(queueType)) {
        this.commInterface.logToServer(
          'info',
          'AppComponent.handleCallQueued',
          'Queue includes in available queue types'
        );
        this.queueService.queuePos = queuePos;
        const navigationExtras: NavigationExtras = {
          queryParamsHandling: 'preserve',
          preserveFragment: true,
          queryParams: { ...this.startService.queryParameters }
        };

        if (this.appConfig.ChatQueueComponent.enableQueueAudio && !this.queueService.isQueueAudioPlaying)
          this.playQueueAudio();
        // route to chat queue component if chatbot feature is disabled
        if (this.appConfig?.chatBot?.enabled) {
          this.commInterface.inQueue.next(queuePos);
        } else {
          if(!this.messengerService.isLiveAgentConnected) {
            this.queueService.setQueueStatus(true);
            this.zone.run(() => {
              this.route.navigate(['chatqueue'], navigationExtras);
            });
          }
        }
      }
    } catch (error) {
      console.error('%c Error Occured in handleCallQueued', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleCallQueued', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.handleCallQueued', JSON.stringify(error));
    }
  };

  /**
   * Method to handle ServerStateChanged when internet goes off or connection drops, calling livechat.Open() to indicate the `RequestFailed` message.
   */
  handleServerStateChanged = () => {
    try {
      let serverStateCount: number = $b.GetLocalStorage('serverStateChangeCount');
      if (serverStateCount !== null) {
        $b.SetLocalStorage('serverStateChangeCount', ++serverStateCount);
        this.getOnlineStatus(serverStateCount) ? this.showAsOnline() : '';
      } else {
        const offlineDateTime = new Date(Date.now());
        this.manageOfflineLogging('Connection between UI and Proxy lost - No Internet', offlineDateTime);
        console.error('Connection between UI and Proxy lost - No Internet', offlineDateTime);
        console.error('Your device is offline!', offlineDateTime);

        $b.SetLocalStorage('serverStateChangeCount', 1);
        this.snackBar.open(this.appLabels.globalLabels?.offlineWarnMessage ?? `Your device is offline!`, 'Dismiss', {
          duration: 3000,
          horizontalPosition: this.snackbarHorizontalPosition || 'center',
          verticalPosition: this.snackbarVerticalPosition || 'top'
        });
      }
      this.commInterface.open();
    } catch (error) {
      console.error('%c Error Occured in handleServerStateChanged', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'handleServerStateChanged', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.handleServerStateChanged',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to check the online status of the application
   * @param statusChangedCount server status change in incrementals
   * @returns boolean based on statesChangedCount
   */
  getOnlineStatus(statusChangedCount): boolean {
    return statusChangedCount % 2 === 0 ? true : false;
  }

  /**
   * Method to register offline timing in localstorage
   * @param data Message data
   * @param time Offline time
   */
  manageOfflineLogging = (data, time) => {
    try {
      const log = {
        message: data,
        offlineTime: time.toString()
      };
      const logArray = [];
      logArray.push(JSON.stringify(log));
      $b.SetLocalStorage('Offline Log', logArray);
      this.commInterface.logToServer('info', 'AppComponent.manageOfflineLogging', JSON.stringify(log));
    } catch (error) {
      console.error('%c Error Occured in manageOfflinElogging', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'manageOfflinElogging', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.manageOfflinElogging',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to notify TMAC server that the application is back online
   */
  showAsOnline(): void {
    try {
      this.snackBar.open(`Back to online`, 'Dismiss', {
        duration: 3000,
        horizontalPosition: this.snackbarHorizontalPosition,
        verticalPosition: this.snackbarVerticalPosition,
        panelClass: ['success-snackbar']
      });
      const offlineLogs = JSON.parse($b.GetLocalStorage('Offline Log'));
      this.commInterface.logToServer('info', 'AppComponent.showAsOnline', JSON.stringify(offlineLogs));
      this.commInterface.sendAppMessage(JSON.stringify(offlineLogs));
      const onlineDateTime = new Date(Date.now());
      this.commInterface.logToServer(
        'error',
        'Connection between UI and Proxy - Back Online',
        onlineDateTime.toString()
      );
      const onlineLog = {
        message: 'Connection between UI and Proxy - Back Online',
        offlineTime: onlineDateTime.toString()
      };
      this.commInterface.sendAppMessage(JSON.stringify(onlineLog));
      if(this.appConfig?.Miscellaneous?.refreshOnBackOnline) location.reload()
    } catch (error) {
      console.error('%c Error Occured in showAsOnline', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'showAsOnline', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.showAsOnline', JSON.stringify(error));
    }
  }

  /*------------------------------------------- Start of TPPVA Events -----------------------------------------------*/

  /**
   * Method to handle TPPVA ChatBotChatStartEvent event
   */
  ChatBotChatStartEvent = (agentId: any, event: any, type: any, islast: any) => {
    try {
      this.log('info', 'ChatBotChatStartEvent', 'Ignore this event', true);
      this.who = 'bot';
      // As we already added the unknown agent as type agent (in handleRemoteUserConnected),
      // in this chatbot start event we assign that agent type as bot
      const agentIndex = this.messengerService.agentList.findIndex((agentObj: any) => agentObj.agentId == agentId);
      if (agentIndex > -1) {
        this.messengerService.agentList[agentIndex].type = 'bot';
        this.messengerService.handleConferenceUsers(this.messengerService.agentList);
      }
    } catch (error) {
      console.error('%c Error Occured in ChatBotChatStartEvent', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'ChatBotChatStartEvent', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.ChatBotChatStartEvent',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to handle TPPVA ChatBotMessageEvent event
   */
  ChatBotMessageEvent = (agentId: any, event: any, type: any, isLast: any) => {
    this.log('info', 'ChatBotMessageEvent', event, true);
  };

  /**
   * Method to handle TPPVA ChatBotOnModuleEvent event
   */
  ChatBotOnModuleEvent = () => {
    this.log('info', 'ChatBotOnModuleEvent', 'Ignore this event', true);
  };

  /**
   * Method to handle TPPVA ChatBotQueuedEvent event
   */
  ChatBotQueuedEvent = (agent, jsonMessage) => {
    const { Headers, Footers } = jsonMessage;
    this.log('info', 'ChatBotQueuedEvent', `Queue headers ${Headers.length} footers ${Footers.length}`, true);
    this.queueService.updateQueueHF(jsonMessage?.EnableHeader ? Headers : [], jsonMessage?.EnableFooter ? Footers : []);
  };

  /**
   * Method to handle TPPVA ChatBotActionEvent event
   */
  ChatBotActionEvent = (message) => {
    try {
      this.log('info', 'ChatBotActionEvent', message.Action, true);
      switch (message.Action) {
        case 'INVOKEFUNCTION':
          this.invokeCustomFunction(message);
          break;
        case 'URLPOP':
          if (this.appConfig?.Miscellaneous?.confirmationOnUrlPop) {
            this.confirmDialog(
              (
                this.appLabels?.globalLabels?.urlPopRedirectWarn ??
                `Visual IVR is trying to navigate to **url**. Do you wish to continue?`
              ).replace('**url**', message.Text),
              '',
              (result) => {
                if (result) window.open(message.Text, '_blank');
              }
            );
          } else window.open(message.Text, '_blank');
          break;
        case 'ShowQueuePop':
          this.queueService.toggleQueueOverlay(true);
          break;
        case 'HideQueuePop':
          this.queueService.toggleQueueOverlay(false);
          break;
        case 'PlayQueueVideo':
          this.queueService.queueVideoData = message.Text;
          this.queueService.updateQueueVideo.next(message);
          break;
        case 'QPOS':
          this.queueService.updateQueuePostionText(message.Text);
          break;
      }
    } catch (error) {
      console.error('%c Error Occured in ChatBotActionEvent', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'ChatBotActionEvent', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.ChatBotActionEvent',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to invoke the custom function in customScript.js file
   * @param message : Action Node data
   */
  invokeCustomFunction(message: any) {
    try {
      const functionName: string = message.Text.split(':')[0];
      const functionParametersArray: string[] = message.Text.split(':')[1].split(',');
      let functionArgumentsArray: any[] = [];

      if (functionParametersArray.length) {
        functionParametersArray.forEach((parameter: string) => {
          if (parameter.includes('$')) {
            switch (parameter.trim().toLowerCase().replace('$', '')) {
              case 'sessionid':
                functionArgumentsArray.push($b.GetSessionStorage('SessionId'));
                break;
              case 'interactionid':
                functionArgumentsArray.push(this.interactionID);
                break;
              case 'agentdata':
                functionArgumentsArray.push(JSON.stringify(this.messengerService.agentList));
                break;
              default:
                break;
            }
          }
        });
      }
      this.commInterface.logToServer(
        'info',
        'AppComponent.invokeCustomFunction',
        `functionName: ${functionName}, functionArguments: ${JSON.stringify(functionArgumentsArray)}`
      );
      if (window.customFunction[functionName]) window.customFunction[functionName](...functionArgumentsArray);
    } catch (error) {
      console.error('%c Error Occured in invokeCustomFunction', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'invokeCustomFunction', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.invokeCustomFunction',
        JSON.stringify(error)
      );
    }
  }

  /**
   * Method to handle TPPVA ChatBotComponentEvent event
   */
  ChatBotComponentEvent = (agentId: any, event: any, type: any, isLast: any) => {
    this.log('info', 'ChatBotComponentEvent', 'received', true);
  };

  /**
   * Method to handle TPPVA ChatBotFormEvent event
   */
  ChatBotFormEvent = (agentId: any, event: any, type: any, isLast: any) => {
    this.log('info', 'ChatBotFormEvent', 'received', true);
  };

  /**
   * Method to handle TPPVA ChatBotHFEvent event
   */
  ChatBotHFEvent = (agentId: any, event: any, type: any, isLast: any) => {
    this.log('info', 'ChatBotHFEvent', 'received', true);
  };

  /**
   * Method to handle TPPVA ChatbotSelfServiceEndedEvent event
   */
  ChatbotSelfServiceEndedEvent = () => {
    try {
      this.log('info', 'ChatbotSelfServiceEndedEvent', 'received', true);
      if (this.appConfig.Miscellaneous.ChatbotSelfServiceEndedRoutingEnabled) {
        this.zone.run(() => {
          this.route.navigate(['chat'], this.UserConnectednavigationExtras);
        });
      }
    } catch (error) {
      console.error('%c Error Occured in ChatbotSelfServiceEndedEvent', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'ChatbotSelfServiceEndedEvent', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.ChatbotSelfServiceEndedEvent',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to generate random color from the given list of color codes
   */
  generateRandomColor(): string {
    try {
      const selectedColor = this.colorCodes[Math.floor(Math.random() * this.colorCodes.length)];
      const index = this.colorCodes.indexOf(selectedColor);
      if (index > -1) {
        this.colorCodes.splice(index, 1);
      }
      return selectedColor;
    } catch (error) {
      console.error('%c Error Occured in generateRandomColor', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'generateRandomColor', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.generateRandomColor',
        JSON.stringify(error)
      );
    }
  }

  /**
   * Assign random theme color to different agents
   */
  assignAgentTheme = () => {
    try {
      if (this.messengerService.agentList.length === 1) {
        this.messengerService.agentList[0].agentTheme = this.defaultFirstAgentTheme;
      } else if (this.messengerService.agentList.length === 2) {
        this.messengerService.agentList[0].agentTheme = this.defaultFirstAgentTheme;
        this.messengerService.agentList[1].agentTheme = this.generateRandomColor();
      } else if (this.messengerService.agentList.length === 3) {
        this.messengerService.agentList[0].agentTheme = this.defaultFirstAgentTheme;
        this.messengerService.agentList[1].agentTheme = this.generateRandomColor();
        this.messengerService.agentList[2].agentTheme = this.generateRandomColor();
      }
    } catch (error) {
      console.error('%c Error Occured in assignAgentTheme', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'assignAgentTheme', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.assignAgentTheme', JSON.stringify(error));
    }
  };

  /**
   * Service worker feature to check for updates
   */
  checkForUpdate() {
    if (this.swupdate.isEnabled) {
      this.swupdate.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe(() => {
        console.log('New version available. Reloading...');
        this.swupdate.activateUpdate().then(() => document.location.reload());
        });
    }
  }

  /**
   * Method to navigate back according to the app configurations
   */
  reloadandReturn = () => {
    try {
      this.commInterface.logToServer('info', 'AppComponent.reloadandReturn', 'Redirecting');
      const navigationExtras: NavigationExtras = {
        queryParamsHandling: 'preserve',
        preserveFragment: true,
        queryParams: { ...this.startService.queryParameters },
        state: { reload: true }
      };

      if (this.appConfig?.Miscellaneous?.CustomStartPageUrl) {
        location.href = this.appConfig?.Miscellaneous?.CustomStartPageUrl + location.search;
      } else {
        if (this.appConfig?.Miscellaneous?.ThankyoupageEnabled) {
          this.zone.run(() => {
            this.route.navigate(['/thank-you'], navigationExtras);
          });
        } else {
          if (this.isCaptchaEnabled === true) {
            this.zone.run(() => {
              this.route.navigate(['/'], navigationExtras);
            });
          } else {
            this.zone.run(() => {
              this.route.navigate(['/'], navigationExtras);
            });
          }
        }
      }
    } catch (error) {
      console.error('%c Error Occured in reloadAndReturn', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'reloadAndReturn', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.reloadAndReturn', JSON.stringify(error));
    }
  };
  /**
   * Method to handle confirm using Matdialog for user acceptance/rejection
   * @param title : Title for the dialog data
   * @param message : message for the dialog component
   * @param onClose : onclose event trigger
   */
  confirmDialog(title: string, message: string, onClose): void {
    try {
      const dialogData = new ConfirmDialogModel(title, message);
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: '400px',
        data: dialogData
      });
      dialogRef.afterClosed().subscribe((dialogResult) => {
        onClose(dialogResult);
      });
    } catch (error) {
      console.error('%c Error Occured in confirmDialog', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'confirmDialog', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.confirmDialog', JSON.stringify(error));
    }
  }

  /**
   * Method to handle events from websocket when websocket is enabled
   * receive data received from websocket service by subscribing to observable
   */
  websocketEvent = () => {
    try {
      this.websocketService.socket$.asObservable().subscribe({
        next: (dataFromServer) => {
          try {
            this.parsedData = $b.IsValidJson(dataFromServer) && JSON.parse(dataFromServer);
            console.log(this.parsedData);
            this.commInterface.logToServer('info', 'AppComponent.websocketEvent', JSON.stringify(this.parsedData));

            if (this.parsedData.InteractionID === null || this.parsedData.InteractionID === '') {
            } else if (this.parsedData.InteractionID) {
              this.interactionID = this.parsedData.InteractionID;
              this.websocketService.interactionID = this.parsedData.InteractionID;
              $b.SetSessionStorage('websocketInteractionID', this.parsedData.InteractionID);
              this.keepAliveWebsocket();
            }

            switch (this.parsedData.EventName) {
              case 'ChatBotActionEvent':
                this.ChatBotActionEvent(this.parsedData);
              case 'ChatBotChatStartEvent':
                this.who = 'bot';
                const extraParams = {
                  interactionId: this.parsedData.InteractionId,
                  profilePicture: '',
                  agentType: 'Chatbot'
                };
                this.handleRemoteUserConnected(
                  this.parsedData.ChatBotName,
                  this.parsedData.Id,
                  this.sessionId,
                  JSON.stringify(extraParams)
                );
                break;
              case 'ChatBotHFEvent':
                this.ChatBotHFEvent('', dataFromServer, '', '');
                this.handleMessageReceivedEvent('Bot', dataFromServer, '', undefined);
                break;
              case 'ChatBotMessageEvent':
                this.handleMessageReceivedEvent('Bot', dataFromServer, '', undefined);
                break;
              case 'ChatBotFormEvent':
                this.handleMessageReceivedEvent('Bot', dataFromServer, '', undefined);
                break;
              case 'InteractionClosedEvent':
                this.websocketService.afterRemoteInteractionEnds();
                break;
              case 'KeepAliveAckEvent':
                this.keepAliveWebsocket();
              default:
                break;
            }
          } catch (error) {
            console.error('%c Error Occured in websocketEvent.websocketService', 'color: red', error);
            this.commInterface.sendUIErrors('AppComponent', 'websocketEvent.websocketService', JSON.stringify(error));
            this.commInterface.logToServer(
              'error',
              'Error occured in AppComponent.websocketEvent.websocketService',
              JSON.stringify(error)
            );
          }
        },
        error: (error) => {
          this.websocketService.socket$.error({ code: 4000, reason: `${error}` });
        },
        complete: () => {
          this.websocketService.endWebSocket(this.websocketService.interactionID);
          const navigationExtras: NavigationExtras = {
            queryParamsHandling: 'preserve',
            preserveFragment: true,
            queryParams: { ...this.startService.queryParameters },
            state: { reload: true }
          };
          if (this.appConfig?.Miscellaneous?.CustomStartPageUrl) {
            location.href = this.appConfig?.Miscellaneous?.CustomStartPageUrl + location.search;
          } else if (this.appConfig.Miscellaneous.ThankyoupageEnabled) {
            this.zone.run(() => {
              this.route.navigate(['/thank-you'], navigationExtras);
            });
          } else {
            this.zone.run(() => {
              this.route.navigate(['/'], navigationExtras);
            });
          }
        }
      });
    } catch (error) {
      console.error('%c Error Occured in websocketEvent', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'websocketEvent', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.websocketEvent', JSON.stringify(error));
    }
  };

  /**
   * Method to initiate ping request to TPPVAWS
   */
  keepAliveWebsocket = () => {
    try {
      setTimeout(() => {
        const data = {
          Command: 'ping',
          Data: '',
          InteractionId: this.websocketService.interactionID
        };
        this.websocketService.sendMessage(data);
      }, 3000);
    } catch (error) {
      console.error('%c Error Occured in keepAliveWebsocket', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'keepAliveWebsocket', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.keepAliveWebsocket',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to handle livechat2 received messages
   */
  livechat2ReceivedMessages = () => {
    this.commInterface.chatBotReceivedMessage.subscribe((x) => {
      try {
        if (typeof x === 'string') {
          const eventData = JSON.parse(x);
          console.log('%c Event Data : ', 'color:white; background: blue;', eventData);
          this.commInterface.logToServer('info', 'AppComponent.livechat2ReceivedMessages', JSON.stringify(eventData));
          if (eventData.InteractionId === null || eventData.InteractionId === '') {
          } else if (eventData.InteractionId) {
            this.interactionID = eventData.InteractionId;
            this.commInterface.interactionID = eventData.InteractionId;
            $b.SetSessionStorage('livechat2InteractionID', eventData.InteractionId);
          }
          this.parseChatBotEvents(eventData.EventName, x);
        }
      } catch (error) {
        console.error('%c Error Occured in livechat2ReceivedMessages', 'color: red', error);
        this.commInterface.sendUIErrors('AppComponent', 'livechat2ReceivedMessages', JSON.stringify(error));
        this.commInterface.logToServer(
          'error',
          'Error occured in AppComponent.livechat2ReceivedMessages',
          JSON.stringify(error)
        );
      }
    });
  };

  /**
   * Method to handle chatbot events
   * @param eventName Name of the event
   * @param chatBotData Chatbot details
   */
  parseChatBotEvents = (eventName, chatBotData) => {
    try {
      this.commInterface.logToServer('info', 'AppComponent.parseChatBotEvents', eventName);
      switch (eventName) {
        case 'ChatBotChatStartEvent':
          console.log('ChatBotChatStartEvent Triggered');
          this.ChatBotChatStartEvent('', chatBotData, '', '');
          break;
        case 'ChatBotHFEvent':
          console.log('ChatBotHFEvent Triggered');
          this.ChatBotHFEvent('', chatBotData, '', '');
          break;
        case 'ChatBotMessageEvent':
          console.log('ChatBotMessageEvent Triggered');
          this.handleMessageReceivedEvent('', chatBotData, '', '');
          break;
        case 'ChatBotFormEvent':
          console.log('ChatBotFormEvent Triggered');
          this.handleMessageReceivedEvent('', chatBotData, '', '');
          break;
        case 'InteractionClosedEvent':
          console.log('InteractionClosedEvent Triggered');
          this.websocketService.afterRemoteInteractionEnds();
          break;
        default:
          break;
      }
    } catch (error) {
      console.error('%c Error Occured in parseChatBotEvents', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'parseChatBotEvents', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.parseChatBotEvents',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Function to create a MatDialog and attach the DevicePermissionsComponent
   * and receive its response once the MatDialog is closed.
   */
  getDevicePermissions = () => {
    try {
      this.isPermissionDialogTriggered = true;
      const dialogRef = this.dialog.open(DevicePermissionsComponent, {
        panelClass: 'dialog-responsive',
        disableClose: true
      });
      dialogRef.afterClosed().subscribe((result) => {
        console.log(result);
      });
    } catch (error) {
      console.error('%c Error Occured in getDevicePermissions', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'getDevicePermissions', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.getDevicePermissions',
        JSON.stringify(error)
      );
    }
  };

  /** Here we process 2 messages from a node detail
   * 1. Title text [which will be sent just like a plain agent message]
   * 2. Node detail to inject respective modules as a message layout
   * @param messageDetails contains whole node details
   * @param agentDetail bot agent detail
   */
  generateMessageToProcess(messageDetails, time, agentDetail) {
    try {
      const message = {
        messageId: '',
        type: 'text',
        message: messageDetails.Text ? messageDetails.Text : messageDetails.Response,
        replyId: '',
        templateId: '',
        attachment: null,
        time: time
      };
      const agent = agentDetail;
      if (messageDetails.NodeType !== 'PROMPT') {
        this.handleAgentMessages(agent, JSON.stringify(message), time);
      }
      if (agent !== 'c') {
        message['type'] = 'bot-layout';
        message['messageId'] =
          messageDetails.MessageId && messageDetails.MessageId !== ''
            ? messageDetails.MessageId
            : messageDetails.EventId;
        message['componentId'] = messageDetails.NodeType;
        message['message'] = '';
        message['nodeDetails'] = {
          ...{
            messageId: message.messageId
          },
          ...messageDetails
        };
        this.handleAgentMessages(agent, JSON.stringify(message), time);
      }
    } catch (error) {
      console.error('%c Error Occured in generateMessageToProcess', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'generateMessageToProcess', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.generateMessageToProcess',
        JSON.stringify(error)
      );
    }
  }

  /**
   * Method to check the browser version support
   */
  checkBrowserSupport = () => {
    try {
      const browser = Bowser.getParser(window.navigator.userAgent);
      const isValidBrowser = browser.satisfies({ ...this.browserOptions });
      this.isBrowserValid = isValidBrowser;
      console.log('Browser Validity - ', isValidBrowser);
      console.log(browser.getBrowser());
      this.commInterface.logToServer('info', 'AppComponent.checkBrowserSupport', `isValidBrowser: ${isValidBrowser}`);
    } catch (error) {
      console.error('%c Error Occured in checkBrowserSupport', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'checkBrowserSupport', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.checkBrowserSupport',
        JSON.stringify(error)
      );
    }
  };

  /**
   * Method to set the app version
   */
  setAppVersion(): void {
    this.appVersion = this.appDataService.getAppVersion();
    console.log('%c App Version - ' + this.appVersion, 'color:black; background: yellow;');
    this.commInterface.logToServer('info', 'AppComponent.SetAppVersion', 'VIVR-Version:' + this.appVersion);
  }

  /**
   * Method to emit a message to parent window, where it will be catched/listened to minimize the iframe.
   */
  emitMinimizeMessage(): void {
    try {
      window.parent.window.postMessage(
        { [this.minimizeTriggerKey]: true },
        this.appConfig?.Miscellaneous?.crossWindowCommunication?.origin
      );
      this.commInterface.logToServer('info', 'AppComponent.emitMinimizeMessage', 'User minimized vivr');
    } catch (error) {
      console.error('%c Error Occured in emitMinimizeMessage', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'emitMinimizeMessage', JSON.stringify(error));
      this.commInterface.logToServer(
        'error',
        'Error occured in AppComponent.emitMinimizeMessage',
        JSON.stringify(error)
      );
    }
  }

  /**
   * Method to emit a message to parent window, where it will be catched/listened to close the iframe.
   */
  emitCloseMessage(): void {
    try {
      window.parent.window.postMessage(
        { [this.closeTriggerKey]: true },
        this.appConfig?.Miscellaneous?.crossWindowCommunication?.origin
      );
      this.commInterface.logToServer('info', 'AppComponent.emitCloseMessage', 'User ended session');
      if (this.appConfig.websocket.enabled) {
        this.websocketService.endWebSocket(this.websocketService.interactionID);
      } else {
        this.commInterface.end('Customer ended', '');
      }
      this.websocketService.afterRemoteInteractionEnds();
    } catch (error) {
      console.error('%c Error Occured in emitCloseMessage', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'emitCloseMessage', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.emitCloseMessage', JSON.stringify(error));
    }
  }

  /**
   * Method to play queue qudio
   */
  playQueueAudio(): void {
    try {
      this.commInterface.audio.volume = this.appConfig.ChatQueueComponent.queueAudioVolume;
      this.commInterface.audio.currentTime = 0;
      this.queueService.isQueueAudioPlaying = true;
      this.commInterface.logToServer('info', 'AppComponent.playQueueAudio', 'Playing queue audio');
    } catch (error) {
      console.error('%c Error Occured in playQueueAudio', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'playQueueAudio', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.playQueueAudio', JSON.stringify(error));
    }
  }

  /**
   * Method to handle annotated image
   * @param data Annotated image data
   */
  onDoneAnnotate(data: any): void {
    try {
      if (data?.annotatedImage) {
        this.commInterface.logToServer('info', 'AppComponent.onDoneAnnotate', 'Received annotated image');
        this.formsService.annotatedDataArray[data.annotatedIndex] = data.annotatedImage;
        this.formsService.annotateImage.next(true);
        this.formsService.showAnnotateContainer = false;
      } else if (data?.cancelAnnotation) {
        this.formsService.showAnnotateContainer = false;
      }
    } catch (error) {
      console.error('%c Error Occured in onDoneAnnotate', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'onDoneAnnotate', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.onDoneAnnotate', JSON.stringify(error));
    }
  }

  /**
   * Method to play the queue audio with volume zero
   */
  playMutedQueueAudioOnLoad(): void {
    try {
      if(this.hasQueueAudioPlayedWithMute || !this.appConfig.ChatQueueComponent.enableQueueAudio) return;
      this.hasQueueAudioPlayedWithMute = true;
      this.commInterface.audio.volume = 0;
      this.commInterface.audio.play();
    } catch (error) {
      console.error('%c Error Occured in playMutedQueueAudioOnLoad', 'color: red', error);
      this.commInterface.sendUIErrors('AppComponent', 'playMutedQueueAudioOnLoad', JSON.stringify(error));
      this.commInterface.logToServer('error', 'Error occured in AppComponent.playMutedQueueAudioOnLoad', JSON.stringify(error));
    }
  }

  isLiveChat1Enabled() {
    if(this.appConfig?.CommunicationInterface?.activeLiveChat == undefined) {
      // old configs has to be used as new one is not updated
      // TODO This config will be deprecated in future 
      return this.appConfig?.CommunicationInterface?.livechat1?.enabled;
    } else {
      // latest config will be used
      return this.appConfig?.CommunicationInterface?.activeLiveChat.toLowerCase() == "livechat1"? true: false;
    }
  }

}
